export const storeToken = (token) => {
  try {
    const jsonValue = JSON.stringify(token);
    localStorage.setItem("token", jsonValue);
  } catch (error) {
    console.log("Error storing the token", error);
  }
};

export const getToken = () => {
  try {
    const jsonValue = localStorage.getItem("token");
    if (jsonValue !== null) {
      return JSON.parse(jsonValue);
    }
  } catch (error) {
    console.log("Error getting the token", error);
  }
};

export const deleteToken = () => {
  try {
    localStorage.removeItem("token");
  } catch (error) {
    console.log("Error deleting the token", error);
  }
};

/**
 * The signed-in member of staff, kept beside the token so a non-React request interceptor can
 * reach it. Only what the audit trail displays: the address Auth0 already told this browser.
 */
export const storeActorEmail = (email) => {
  try {
    if (email) localStorage.setItem("actorEmail", email);
    else localStorage.removeItem("actorEmail");
  } catch (error) {
    console.log("Error storing the actor", error);
  }
};

export const getActorEmail = () => {
  try {
    return localStorage.getItem("actorEmail") ?? null;
  } catch (error) {
    console.log("Error getting the actor", error);
    return null;
  }
};

export const deleteActorEmail = () => {
  try {
    localStorage.removeItem("actorEmail");
  } catch (error) {
    console.log("Error deleting the actor", error);
  }
};
